module.exports = __webpack_public_path__ + "img/l-cb6-r2-green.23103fbf.gif";